export class Error{
  type: string;
  message:string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/error.ts